<template>
    <ToolButton :Editor="Editor" KnownIcon="TableInsertColumnLeft"
        @ToolClick="Editor.chain().focus().addColumnBefore().run()" :Size="10">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>